//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IListManagerItem } from 'unison';

export enum CONNECT_PANEL_ACTIONS {
  CHANGE_LOCALE = 'CONNECT_PANEL_ACTIONS/CHANGE_LOCALE',
  CHANGE_CONNECTION_METHOD = 'CONNECT_PANEL_ACTIONS/CHANGE_UPLOAD_METHOD',
  TOGGLE_IS_VALIDATING = 'CONNECT_PANEL_ACTIONS/TOGGLE_IS_VALIDATING',
  SET_IS_URL_EMPTY = 'CONNECT_PANEL_ACTIONS/SET_IS_URL_EMPTY',
  SET_IS_CATALOG_SOURCE_VALID = 'CONNECT_PANEL_ACTIONS/SET_IS_CATALOG_SOURCE_VALID',
  SET_IS_FILE_UPLOADING = 'CONNECT_PANEL_ACTIONS/SET_IS_FILE_UPLOADING',
  SET_DID_FILE_UPLOAD_FAIL = 'CONNECT_PANEL_ACTIONS/SET_DID_FILE_UPLOAD_FAIL',
  CHANGE_LOGIN = 'CONNECT_PANEL_ACTIONS/CHANGE_LOGIN',
  CHANGE_PASSWORD = 'CONNECT_PANEL_ACTIONS/CHANGE_PASSWORD',
  CHANGE_URL = 'CONNECT_PANEL_ACTIONS/CHANGE_URL',
  RESET_CATALOG_URL_CREDENTIALS_STATE = 'CONNECT_PANEL_ACTIONS/RESET_CATALOG_URL_CREDENTIALS_STATE',
  REQUEST_VALIDATE_SOURCE = 'CONNECT_PANEL_ACTIONS/REQUEST_VALIDATE_SOURCE',
  RECEIVE_VALIDATE_SOURCE = 'CONNECT_PANEL_ACTIONS/RECEIVE_VALIDATE_SOURCE',
}

export enum CATALOG_LOCALE_TYPES {
  EN_US = 'en-us',
  EN_CA = 'en-ca',
  EN_GB = 'en-gb',
  FR_FR = 'fr-fr',
  DE_DE = 'de-de',
  EN_AU = 'en-au',
  IT_IT = 'it-it',
  ES_ES = 'es-es',
  NL_NL = 'nl-nl',
  EN_IE = 'en-ie',
  KO_KR = 'ko-kr',
}

export enum CONNECTION_METHODS {
  CatalogURL = 'CatalogURL',
  FileUpload = 'FileUpload',
}

export const CATALOG_LOCALE_TYPES_LABELS = {
  [CATALOG_LOCALE_TYPES.EN_US]: 'English (United States)',
  [CATALOG_LOCALE_TYPES.EN_CA]: 'English (Canada)',
  [CATALOG_LOCALE_TYPES.EN_GB]: 'English (United Kingdom)',
  [CATALOG_LOCALE_TYPES.EN_AU]: 'English (Australia)',
  [CATALOG_LOCALE_TYPES.EN_IE]: 'English (Ireland)',
  [CATALOG_LOCALE_TYPES.FR_FR]: 'French (France)',
  [CATALOG_LOCALE_TYPES.DE_DE]: 'German (Germany)',
  [CATALOG_LOCALE_TYPES.IT_IT]: 'Italian (Italy)',
  [CATALOG_LOCALE_TYPES.ES_ES]: 'Spanish (Spain)',
  [CATALOG_LOCALE_TYPES.NL_NL]: 'Dutch (Netherlands)',
  [CATALOG_LOCALE_TYPES.KO_KR]: 'Korean (South Korea)',
};

export const getLocaleOptions = (): Array<IListManagerItem<string>> => {
  return Object.keys(CATALOG_LOCALE_TYPES_LABELS).map((key) =>
    ({
      label: CATALOG_LOCALE_TYPES_LABELS[key],
      value: key,
    })
  );
};
